// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"animation_fadeIn__7T_A_","fade-in":"animation_fade-in__frEUg","slideIn":"animation_slideIn___G9jN","slide-in":"animation_slide-in__nta2_"};